import posthog from 'posthog-js';
import { Dispatch } from 'react';
import { NavigateFunction } from 'react-router-dom';
import { PostMetadataDTO } from 'services/api/models/PostDTO';
import { routes } from 'services/RouteService';
import { contentActions } from 'store/content';

export type PosthogOnArticleOpenExtras = {
  opened_on_page: string;
  referring_article_id?: string;
  found_using_tag?: string;
  found_using_search?: string;
  /** Slug of the category page the article was opened from (categorised Infos page) */
  found_using_category?: string;
};

export default function onArticleSelected(
  post: PostMetadataDTO,
  articleRank: number,
  navigate: NavigateFunction,
  dispatch: Dispatch<any>,
  posthogOnArticleOpenExtras?: PosthogOnArticleOpenExtras,
) {
  posthog.capture('info.post_opened', {
    post_id: post.id,
    post_title: post.title,
    rank_in_list: articleRank,
    ...posthogOnArticleOpenExtras,
  });
  navigate(routes.article.route.replace(':index', post.id.toString()));
  dispatch(contentActions.markPostAsRead(post.id));
}
